import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';
import { G as GoogleLoginUxMode } from '../../chuck/GoogleLoginUxMode-CI3mpvZT.js';
import { r as requireScriptLoader } from '../../chuck/scriptLoader-C7O-_j6M.js';

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var GoogleSdkLogin = /*#__PURE__*/ _async_to_generator$1(function(config) {
    var _window_google;
    return _ts_generator$1(this, function(_state) {
        try {
            ;
            if (!((_window_google = window.google) == null ? void 0 : _window_google.accounts)) {
                return [
                    2,
                    {
                        status: SocialLoginResponseStatus.LoadError
                    }
                ];
            }
            return [
                2,
                new Promise(function(resolve) {
                    var _config_scope;
                    var authConfig = {
                        client_id: config.clientId,
                        scope: (_config_scope = config.scope) != null ? _config_scope : ''
                    };
                    var _config_uxMode;
                    var uxMode = (_config_uxMode = config.uxMode) != null ? _config_uxMode : GoogleLoginUxMode.Popup;
                    var client = window.google.accounts.oauth2.initCodeClient(_extends({}, authConfig, {
                        ux_mode: uxMode,
                        callback: function(response) {
                            return resolve({
                                code: response.code,
                                status: SocialLoginResponseStatus.Success
                            });
                        },
                        error_callback: function(response) {
                            if ((response == null ? void 0 : response.type) === 'popup_closed') {
                                return resolve({
                                    status: SocialLoginResponseStatus.UserCancelled
                                });
                            }
                            return resolve({
                                status: SocialLoginResponseStatus.Error,
                                error: response == null ? void 0 : response.type
                            });
                        }
                    }));
                    return client.requestCode();
                })
            ];
        } catch (error) {
            return [
                2,
                {
                    status: SocialLoginResponseStatus.Error,
                    error: "" + error
                }
            ];
        }
        return [
            2
        ];
    });
});

var loadGoogleGsiClient = {};

var loadGsiClient = {};

var hasRequiredLoadGsiClient;
function requireLoadGsiClient() {
    if (hasRequiredLoadGsiClient) return loadGsiClient;
    hasRequiredLoadGsiClient = 1;
    var __assign = loadGsiClient && loadGsiClient.__assign || function() {
        __assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var __awaiter = loadGsiClient && loadGsiClient.__awaiter || function(thisArg, _arguments, P, generator) {
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : new P(function(resolve) {
                    resolve(result.value);
                }).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = loadGsiClient && loadGsiClient.__generator || function(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var _this = loadGsiClient;
    Object.defineProperty(loadGsiClient, "__esModule", {
        value: true
    });
    var scriptLoader_1 = requireScriptLoader();
    var SCRIPT_ID = 'google-gsi-client';
    var injectGsiClientScript = function injectGsiClientScript(options) {
        return scriptLoader_1.ScriptLoader.LoadScriptAsync(__assign({
            src: 'https://accounts.google.com/gsi/client',
            id: SCRIPT_ID
        }, options));
    };
    loadGsiClient.injectGsiClientScript = injectGsiClientScript;
    var initGoogleGsiClient = function initGoogleGsiClient(configuration, momentListener) {
        return new Promise(function(resolve, reject) {
            if (window.google && window.google.accounts.id) {
                window.google.accounts.id.initialize(configuration);
                window.google.accounts.id.prompt(momentListener);
                return resolve(window.google.accounts);
            }
            reject('Gsi Client Instance does not exist.');
        });
    };
    var loadGsiClient$1 = function loadGsiClient(params) {
        return __awaiter(_this, void 0, void 0, function() {
            var error_1;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (window.google && window.google.accounts.id) {
                            return [
                                2 /*return*/ ,
                                window.google.accounts
                            ];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            injectGsiClientScript(params.scriptOptions)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            initGoogleGsiClient(params.configuration, params.momentListener)
                        ];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error(error_1);
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    loadGsiClient.loadGsiClient = loadGsiClient$1;
    
    return loadGsiClient;
}

var hasRequiredLoadGoogleGsiClient;
function requireLoadGoogleGsiClient() {
    if (hasRequiredLoadGoogleGsiClient) return loadGoogleGsiClient;
    hasRequiredLoadGoogleGsiClient = 1;
    Object.defineProperty(loadGoogleGsiClient, "__esModule", {
        value: true
    });
    var loadGsiClient_1 = requireLoadGsiClient();
    loadGoogleGsiClient.loadGsiClient = loadGsiClient_1.loadGsiClient;
    loadGoogleGsiClient.injectGsiClientScript = loadGsiClient_1.injectGsiClientScript;
    
    return loadGoogleGsiClient;
}

var loadGoogleGsiClientExports = requireLoadGoogleGsiClient();

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var GoogleSdkLoader = /*#__PURE__*/ _async_to_generator(function(config) {
    return _ts_generator(this, function(_state) {
        if (!window.google) {
            return [
                2,
                loadGoogleGsiClientExports.injectGsiClientScript({
                    async: true,
                    defer: true
                }).then(function(response) {
                    return !!response;
                })
            ];
        }
        return [
            2,
            Promise.resolve(!!window.google)
        ];
    });
});

export { GoogleSdkLoader, GoogleSdkLogin };
